import { UPDATE_PAGE_TITLE } from '../actions/pageInfo'

const initialState = {
  pageTitle: null
}
const pageInfoReducers = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAGE_TITLE:
      //console.log(action.pageTitle, state.pageTitle,action.pageTitle !== state.pageTitle)
      if (action.pageTitle !== state.pageTitle) {
        return {
          ...state,
          pageTitle: action.pageTitle
        }
      }

      return state

    default:
      return state
  }
}

export default pageInfoReducers
